import React from 'react';

/**
 * AttributeStack: label over value pattern
 */
export const AttributeStack = ({ label, value, icon, variant = 'default', style }) => {
    const isValueLarge = variant === 'large';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', ...style }}>
            <label style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                opacity: 0.5,
                letterSpacing: '0.05em'
            }}>
                {label}
            </label>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: isValueLarge ? '1.1rem' : '0.95rem',
                fontWeight: 600,
                color: 'var(--color-text-primary)'
            }}>
                {icon && <span style={{ opacity: 0.5, display: 'flex' }}>{icon}</span>}
                {value}
            </div>
        </div>
    );
};

/**
 * AttributeGrid: Container for multiple AttributeStacks
 */
export const AttributeGrid = ({ children, columns = 'auto-fit', minWidth = '200px', gap = '2.5rem', style }) => {
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(${minWidth}, 1fr))`,
            gap: gap,
            ...style
        }}>
            {children}
        </div>
    );
};
